import type { EntityCtx } from '@cli-types/next-adapter/generators.js'

export function genBarrelContent(
  files: Array<{ name: string; content: string }>,
  ctx: EntityCtx
): string {
  const lines: string[] = []

  const typeNames: string[] = [
    `${ctx.Singular}`,
    `${ctx.Plural}Page`,
    `${ctx.Plural}Query`,
    `${ctx.Singular}CreateInput`,
    `${ctx.Singular}CreateResult`,
    `${ctx.Singular}UpdateInput`,
    `${ctx.Singular}UpdateResult`,
    `${ctx.Singular}DeleteResult`,
    ctx.hasCreatableSelectFields ? `${ctx.Singular}SelectOption` : null,
    ctx.hasCreatableSelectFields ? `${ctx.Singular}SelectOptionFieldName` : null,
    ctx.hasCreatableSelectFields ? `Create${ctx.Singular}SelectOptionInput` : null,
    ctx.hasCreatableSelectFields ? `Create${ctx.Singular}SelectOptionResult` : null
  ].filter(Boolean) as string[]
  lines.push(`export type { ${typeNames.join(', ')} } from './types'`)
  lines.push('')

  for (const file of files) {
    if (file.name === 'types.ts' || file.name === 'helpers.ts' || file.name === 'markdown.ts')
      continue
    const exportMatches = file.content.matchAll(/export async function (\w+)/g)
    const fnNames = [...exportMatches].map((m) => m[1])
    if (fnNames.length > 0) {
      const modulePath = `./${file.name.replace(/\.ts$/, '')}`
      lines.push(`export { ${fnNames.join(', ')} } from '${modulePath}'`)
    }
  }

  lines.push('')
  return lines.join('\n')
}
